const English = {
	Schedule: 'Schedule',
	Medication: 'Medication',
	Education: 'Education',
	LabReport: 'Lab Report',
	VisitHistory: 'Visit History',
	Vaccination: 'Vaccination',
	MyMonitor: 'myMonitor',
	InviteFriend: 'Invite Friends',
	NearByPharmacy: 'Pharmacy',
	Telehealth: 'Telehealth',
	Vaccine: 'Vaccine',
	MedicalFiles: 'Medical Files',
	Message: 'Message',
	Insurance: 'Insurance',
	New: 'New',
	BookAppointmentForCovid19Vaccination: 'Book an Appointment for COVID-19 Vaccination',
	BookFromSomos: 'Book from SOMOS Community Care',
	ApologizeForNoTimeSlots: 'We apologize for the inconvenience, there is no available time slots at this time. Please check back later.',
	VaccineQualification: 'Vaccine Qualification',
	NoUpComingAppointment: 'You have no upcoming appointments.',
	UpcomingAppointments: 'Upcoming Appointments',
	AppointmentShowUp: 'Your vaccination record will show up here if you’ve recieved your COVID-19 vaccine.',
	FirstName: 'First Name',
	LastName: 'Last Name',
	MidName: 'Mi',
	dob: 'Date of Birth',
	VaccinationRecord: 'Vaccination Record',
	Coivd19AndYou: 'COVID-19 & You',
	January: 'January',
	February: 'February',
	March: 'March',
	April: 'April',
	May: 'May',
	June: 'June',
	July: 'July',
	August: 'August',
	September: 'September',
	October: 'October',
	November: 'November',
	December: 'December',
	Sunday: 'Sunday',
	Monday: 'Monday',
	Tuesday: 'Tuesday',
	Wednesday: 'Wednesday',
	Thursday: 'Thursday',
	Friday: 'Friday',
	Saturday: 'Saturday',
	GetDirection: 'Get Directions',
	AppointmentInfo: 'Appointment Information',
	CancelAppointment: 'Cancel Appointment',
	GetVaccinatedTIps1: '1. Bring a photo ID and your health insurance card, if you have one, to your appointment.',
	GetVaccinatedTIps2: '2. Bring proof of eligibility for the vaccine to your appointment. This can include an employee ID card, a letter from your employee or affiliated organization, or a pay stub.',
	ArriveEarly: 'Arrive 15 minutes early!',
	PageNotFound: 'We can’t seem to find what you’re looking for.',
	OOPS: 'Oops!',
	NotSomosData: 'Not seeing your SOMOS vaccination appointment or record details?',
	SyncNow: 'Sync Now',
	ReadMore: 'Read More',
	InPerson: 'In-person',
	Virtual: 'Virtual',
	ViewAll: 'View All',
	BookAppointment: 'Book Appointment',
	NoAvailableDays: 'No appointments are currently available for this day - please select a different day :)',
	pleaseSelectLocation:'Please select a clinic location to view available appointments.',
	HowToActiveMyAccount: 'How to modify my personal profile information?',
	HowToActiveMyAccountDesc1: '1. Go to  **Settings**  tab, and click the avatar icon on the top',
	HowToActiveMyAccountDesc2: '2. Click **Edit** to modify all information or click the specific information that needs to be modified',
	HowToSaveOrPrintMyVaccine: 'How to save or print my vaccination record?',
	HowToSaveOrPrintMyVaccineDesc1: '1. Go to  **Vaccination tab** and click the **...** icon in the top right corner\n\n',
	HowToSaveOrPrintMyVaccineDesc1_1: '2. Click **Open in browser** ',
	HowToSaveOrPrintMyVaccineDesc2: '3. For **Android phone users**:\n\n&nbsp;&nbsp;1. Click the icon on the top right corner of browser',
	HowToSaveOrPrintMyVaccineDesc2_1: '&nbsp;&nbsp;2. Click **Share...** on the menu',
	HowToSaveOrPrintMyVaccineDesc2_2: '&nbsp;&nbsp;3. Click **Print** ',
	HowToSaveOrPrintMyVaccineDesc3: '4. For **iPhone phone users** :\n\n&nbsp;&nbsp;1. Click the share icon at the bottom of browse',
	HowToSaveOrPrintMyVaccineDesc3_1: '&nbsp;&nbsp;2. Click **Print** on the pop-up menu',
	HowToActiveMyAccountToRetrieveMedicalInformation: 'How to active my account to retrieve more medical information?',
	HowToActiveMyAccountToRetrieveMedicalInformationSubTitle: '_Please make sure you have already obtained the “AccessCode/Registration code”from your doctor before activating your account._',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc1: '1. Go to __Settings__ tab\n\n' +
		'2. Click **Retrieve Medical Record** \n\n',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc2: '3. Enter the code obtained from doctor\n\n' +
		'4. Click **Activate**',
	HowToSendMessage: 'How to send messages to doctor?',
	HowToSendMessageSubTitle: '_If you have booked an appointment with your doctor then you can send messages to doctor via **Telehealth** portal._',
	HowToSendMessageDesc1: '1. **If appointment is booked with doctor**\n\n' +
		'&nbsp;&nbsp;a. Go to **Telehealth** tab\n\n'+
		'&nbsp;&nbsp;b. Click the **Camera** icon to enter chat room\n\n',
	HowToSendMessageDesc2: '2. **If appointment is --NOT-- booked with doctor** \n\n' +
		'For users using the **New UI** in main screen display:\n\n' +
		'&nbsp;&nbsp;a. After successfully login to iClinicHealth\n\n' +
		'&nbsp;&nbsp;b. Go to **Inbox** tab and click **Load more** under Message section\n\n' +
		'&nbsp;&nbsp;c. Click the **Pencil** icon on the bottom right corner to draft new message\n\n' +
		'&nbsp;&nbsp;d. Click the **Contact** icon on the top right corner to add doctor contact to fill in Subject and content, then click **Send** ',
	HowToSendMessageDesc3: 'For users using the Old UI in main screen display:\n\n' +
		'&nbsp;&nbsp;e. After successfully login to iClinicHealth\n\n' +
		'&nbsp;&nbsp;f. Go to  **Message** tab\n\n' +
		'&nbsp;&nbsp;g. Click the  **Pencil** icon on the bottom right corner to draft new message\n\n' +
		'&nbsp;&nbsp;h. Click the **Contact** icon on the top right corner to add doctor contact to fill in Subject and content, then click **Send** ',
	HowToExtraAccountsForFamily: 'How to add extra accounts for family members?',
	HowToExtraAccountsForFamilyDesc1: '1. Go to **Settings** tab\n\n' +
		'2. Click **Switch User**',
	HowToExtraAccountsForFamilyDesc2: '3. Click **+** icon',
	HowToExtraAccountsForFamilyDesc3: '4. Enter new account credentials for new user login',
	HowToLinkSomosAccount: 'How to link SOMOS account to retrieve COVID-19 vaccination record?',
	HowToLinkSomosAccountDesc1: '1. Go to **Vaccine** tab \n\n2. Click **Sync Now**',
	HowToLinkSomosAccountDesc3: '3. Enter the SOMOS account information and click verify',
	HowToLinkSomosAccountDesc4: '4. Then you will be able to view your COVID-19 vaccination record',
	HowToSendFeedBack:  'How to send feedback about incorrect provider information?',
	HowToSendFeedBackDesc1: '1. Go to  **Settings** tab\n\n' +
		'2. Click  **Help & Feedback**',
	HowToSendFeedBackDesc2: '3. Click the icon next to “General Feedback”',
	HowToSendFeedBackDesc3: '4. Select option **Incorrect Provider Information** and type in the context and click send on the top right corner',
	SendFeedBackAndAskQuestion: 'Send Feedback or Ask a Question',
	HelpAndFeedBack: 'Help & Feedback',
	HowToUseAccessCode: 'How to do a telehealth visit immediately using iClinicHealth “Access Code”?',
	HowToSignUp: 'How to sign up to iClinicHealth?',
	HowToSearchAndBookAppointment: 'How to search and book an appointment with iClinicHealth?',
	HowToUseTeleMedicine: 'How to use telemedicine?',
	HowToBookTeleHealth: 'How to book a telehealth appointment through iClinicHealth?',
	HowToAccessTeleHealthWithCode: 'How to access telehealth via access code?',
	HowToShareFiles: 'How to share files through telehealth?',
	FindADoctor: 'Try doctor’s name, specialty',
	DoctorList: 'Doctor List',
	PopSearch: 'Popular Searches',
	Specialty: 'Specialty',
	SelectASpecialty: 'Select a Specialty',
	LanguagePreference: 'Language Preferences',
	DoctorGender: 'Doctor\'s Gender',
	Female: 'Female',
	Male: 'Male',
	DoesnotMatter: 'Doesn’t matter',
	AppointmentType: 'Appointment Type',
	AnyType: 'Any type',
	AvailableTime: 'Available Time',
	Today: 'Today',
	InAWeek: 'In a week',
	InAMonth: 'In a month',
	AnyDays: 'Any days',
	AppleFilter: 'Apply Filter',
	Clear: 'Clear',
	AnySpecialty: 'Any Specialty',
	Hide:'Hide',
	LocationAndContact: 'Location & Contact',
	SelectATime: 'Select Time',
	NoMoreAvailableAppointmentSlots: 'No available appointment slots',
	NoMoreAvailableOfficeLocation: 'No available office location',
	Alert: 'Alert',
	NoSelectedAvailableTime: 'Please select a time',
	NoAvailableTIme: 'No appointments are currently available for this day – please select a different day :) ',
	NoAvailableLocations: 'No appointments are currently available',
	YourAppointmentIsConformed: 'your appointment is confirmed.',
	MyAppointment: 'Go to My Appointment',
	MemoPlaceHolder: 'Is there anything you want to let the doctor know before the appointment?',
	DoctorProfile: 'Doctor\'s Profile',
	Scan: 'Scan',
	InvalidQRCode: 'Invalid QR code',
	ScanCorrectQRCodeTips: 'Please scan the correct QR code',
	GetDoctorInfoFailed: 'Get doctor information failed',
	AppointmentDetail: 'Appointment Details',
	NoResultFound: 'No Matching Results.',
	SearchSuggestions: 'Search Suggestions: ',
	CheckYourSpelling: 'Check your spelling',
	TryMoreGeneralWords: 'Try more general words',
	UseFilter1: 'Browse our ',
	UseFilter2: 'doctor list',
	UseFilter3: ' and use filter to find the right doctor',
	UseQRCodeToBookAppointment: 'Use the QR code below to book an appointment with your doctor from our app directly.',
	QRCodeManageAppointment: 'With our app, you can also manage your appointments, do virtual check-ins, and access your medical record and visit history. Everything in one place!',
	CurrentNotAvailable: 'Currently Unavailable',
	RecentSearch: 'Recent Searches',
	LoadMore: 'Load more',
	NoMoreRecords: 'No more records',
	OfficeLocationUnspecified: 'Office location unspecified',
	Call: 'Call Clinic',
	Share: 'Share',
	OpenWithBrowser: 'Open with Browser',
	ThankYou: 'Thank you!',
	VerifyNotes1: 'We need to verify your identity before linking your ',
	Healthix: 'Healthix',
	VerifyNotes2: ' health data to this account so we keep your medical record secure.',
	WhatIsIdme: 'What is ID.me?',
	IDmeNote: 'Verify once and unlock access to exclusive features only available to verified guests. ',
	LearnMore: 'Learn More',
	VerifySuccessNote: "We’ve verified your identity! You can check your report(s) from Healthix in Lab Report once available. ",
	IdentityVerification: 'Identity Verification',
	TypeOfAppointment: 'Type of Appointment',
	OfficePhoneNumber: 'Office Phone Number',
	Address: 'Address',
	AppointmentMemo: 'Appointment Memo',
	Nearest: 'Nearest',
	Cancel: 'Cancel',
	EarliestAvailability: 'Earliest Availability',
	ShareDoctorTitle: "I recommend a great doctor I found on iClinicHealth app.",
	SeeMonthlyView: 'See Monthly View',
	SaveImageAsProfile: 'Save Profile  as Image',
	CopyProfileLink: 'Copy Profile Link',
	Copied: 'Link copied',
	InSpecialty: 'In Specialty',
	BookFailed: 'Book Failed',
	PrimaryCare: 'Internal Medicine, Family Medicine, Primary Care',

	PrimaryCares: 'Primary Care',
	InternalMedicine: 'Internal Medicine',
	FamilyMedicine: 'Family Medicine',
	Pediatrics: 'Pediatrics',
	OBGYN: 'OB-GYN',
	PainManagement: 'Pain Management',
	Jan: 'Jan',
	Feb: 'Feb',
	Mar: 'Mar',
	Apr: 'Apr',
	Mays: 'May',
	Jun: 'Jun',
	Jul: 'Jul',
	Aug: 'Aug',
	Sep: 'Sep',
	Oct: 'Oct',
	Nov: 'Nov',
	Dec: 'Dec',
	Sun: 'Sun',
	Mon: 'Mon',
	Tue: 'Tue',
	Wed: 'Wed',
	Thu: 'Thu',
	Fri: 'Fri',
	Sat: 'Sat',
	Feedback: 'Feedback',
	GeneralFeedback: 'General feedback',
	IncorrectProviderInformation: 'Incorrect provider information',
	ScheduleAnAppointment: 'Schedule an appointment',
	FindDoctor: 'Find a Doctor',
	OtherQuestions: 'Other questions',
	Email: 'Email',
	FeedbackDetails: 'Feedback details',
	SendFeedback: 'Send Feedback',
	FeedbackContentPlaceholder: 'Leave us a message and we will get back to you!',
	PleaseEnterEmailAddress: 'Please enter your email address.',
	PleaseEnterValidEmail: 'Please enter a valid email address.',
	PleaseEnterFeedbackDetails: 'Please enter the Feedback details.',
	Confirmation: 'Confirmation',
	ThanksForYourFeedback: 'Thanks for your feedback',
	OurSupportTeamIsOnIt: 'Our support team is on it.',
	YouWillGetEmailReplySoon: 'You will get an email reply soon.',
	BackToHome: 'Back to Home',
	RequestFailed: 'Request failed, please try again.',
	ContactUs: 'Contact Us',
	GoBack: 'Go Back',
	Yesterday: 'Yesterday',
	MeasureHistory: 'Measure History',
	AddData: 'Add data',
	ShowAllMeasureHistory: 'Show all measure history',
	AllRecordedData: 'All Recorded Data',
	UnitSettings: 'Unit Settings',
	Save: 'Save',
	LastWeek: 'Last Week',
	LastMonth: 'Last Month',
	LastQuarter: 'Last Quarter',
	LastYear: 'Last Year',
	AllTime: 'All Time',
	Average: 'Average',
	High: 'High',
	Low: 'Low',
	NoRecentData: 'No Recent Data',
	About: 'About',
	Options: 'Options',
	Unit: 'Unit',
	ShowAllData: 'Show All Data',
	Systolic: 'Systolic',
	Diastolic: 'Diastolic',
	Invalid: 'Invalid',
	SubmitSuccess: 'Submitted successfully',
	Date: 'Date',
	Time: 'Time',
	BloodPressure: 'Blood Pressure',
	BloodOxygen: 'Blood Oxygen',
	BloodGlucose: 'Blood Glucose',
	HeartRate: 'Heart Rate',
	Temperature: 'Temperature',
	Height: 'Height',
	Weight: 'Weight',
	NoData: 'No data',
	Source: 'Source',
	BodyTemperature: 'Body Temperature',
	ManualInput: 'Manual Input',
	YourBMI: 'Your BMI',
	CalculateBaseOnLatestValue: 'calculated based on your latest height and weight',
	Add: 'add',
	GetYourBMICalculated: 'to get your BMI calculated',
	WeAreUpdatingMyMonitorView: 'We are updating the myMonitor view.',
	GoTo: 'Go to',
	ToSeeTheOldView: 'to see the old view',
	MyAccount: 'My Account',
	AddNewRecordTips: 'No recent data? Click to add a new record.',
	InMaintenance: 'In Maintenance',
	AppointmentCalendarTips: (doctorName, appointmentTime, officeLocation, officePhone) => {
		let tips = 'Your appointment with Dr.' + doctorName;

		if (officeLocation) {
			tips += (' (' + officeLocation)
		}
		if (officePhone) {
			tips += (', ' + officePhone)
		}

		if (officeLocation || officePhone) {
			tips += ')'
		}

		if (appointmentTime) {
			tips += (' at ' + appointmentTime)
		}

		tips += ' is coming.';
		return tips
	},
}

const Spanish = {
	Schedule: 'Calendario',
	Medication: 'Medicamento',
	Education: 'Educación',
	LabReport: 'Informe de laboratorio',
	VisitHistory: 'Historia medica',
	Vaccination: 'Vacunación',
	MyMonitor: 'myMonitor',
	InviteFriend: 'Invitar a amigos',
	NearByPharmacy: 'Farmacia',
	Telehealth: 'Telesalud',
	Vaccine: 'Vacuna',
	MedicalFiles: 'Archivos médicos',
	Message: 'Mensajes',
	Insurance: 'Seguro',
	New: 'Nuevo',
	BookAppointmentForCovid19Vaccination: 'Reserve una cita para la vacunación COVID-19',
	BookFromSomos: 'Reserve una cita de SOMOS Community Care',
	ApologizeForNoTimeSlots: 'Lamentamos las molestias, no hay franjas horarias disponibles en este momento. Por favor, vuelva más tarde.',
	VaccineQualification: 'Calificación de la vacuna',
	UpcomingAppointments: 'Próximas Citas',
	AppointmentShowUp: 'Su registro de vacunación aparecerá aquí si ha recibido la vacuna COVID-19.',
	FirstName: 'Nombre',
	LastName: 'Apellido',
	MidName: 'Medio',
	dob: 'Fecha de nacimiento',
	VaccinationRecord: 'Registro de vacunación',
	Coivd19AndYou: 'COVID-19 y usted',
	January: 'enero',
	February: 'febrero',
	March: 'marzo',
	April: 'abril',
	May: 'mayo',
	June: 'junio',
	July: 'julio',
	August: 'agosto',
	September: 'septiembre',
	October: 'octubre',
	November: 'noviembre',
	December: 'diciembre',
	Sunday: 'domingo',
	Monday: 'lunes',
	Tuesday: 'martes',
	Wednesday: 'miércoles',
	Thursday: 'jueves',
	Friday: 'viernes',
	Saturday: 'sábado',
	GetDirection: 'Obtener las direcciones',
	AppointmentInfo: 'Información de cita',
	CancelAppointment: 'Cancelar cita',
	GetVaccinatedTIps1: '1. Lleve a su cita un documento de identidad con fotografía y su tarjeta de seguro médico, si la tiene',
	GetVaccinatedTIps2: '2. Lleve a su cita una prueba de que puede recibir la vacuna. Esto puede incluir una tarjeta de identificación de empleado, una carta de su empleado u organización afiliada, o un talón de pago.',
	ArriveEarly: '¡Llegue 15 minutos antes!',
	NoUpComingAppointment: 'No tiene ninguna cita próxima.',
	PageNotFound: 'Parece que no podemos encontrar lo que está buscando.',
	OOPS: 'Oops!',
	NotSomosData: '¿No ve los detalles de su cita o registro de vacunación de SOMOS?',
	SyncNow: 'Sincronizar ahora',
	ReadMore: 'Lee mas',
	InPerson: 'En persona',
	Virtual: 'Virtual',
	ViewAll: 'Ver todo',
	BookAppointment: 'Reservar cita',
	NoAvailableDays: 'Actualmente no hay citas disponibles para este día- seleccione un día diferente :)',
	pleaseSelectLocation:'Seleccione una ubicación de la clínica para ver las citas disponibles.',
	HowToActiveMyAccount: 'Cómo modificar la información de mi perfil personal?',
	HowToActiveMyAccountDesc1: '1. Vaya a la pestaña  **Configuración** ,haga clic en el icono de avatar en la parte superior:',
	HowToActiveMyAccountDesc2: '2. Haga clic en  **Editar** para modificar toda la información o haga clic en la información específica que necesita ser modificada',
	HowToSaveOrPrintMyVaccine: 'Cómo guardar o imprimir mi registro de vacunación?',
	HowToSaveOrPrintMyVaccineDesc1: '1. Vaya a la  **Vacunación** y haga clic en el icono  **...** en la esquina superior derecha: \n\n',
	HowToSaveOrPrintMyVaccineDesc1_1:
		'2. Haga clic en  **Abrir en el broswer** ',
	HowToSaveOrPrintMyVaccineDesc2: '3. Para  **usuarios de teléfonos Android**:\n\n' +
		'&nbsp;&nbsp;1. Haga clic en **** icono en la esquina superior derecha del navegador\n\n' +
		'&nbsp;&nbsp;2. Haga clic en **Share...** en el menú\n\n' +
		'&nbsp;&nbsp;3. Haga clic en **Print** ',
	HowToSaveOrPrintMyVaccineDesc2_1:
		'&nbsp;&nbsp;2. Haga clic en **Share...** en el menú',
	HowToSaveOrPrintMyVaccineDesc2_2: '&nbsp;&nbsp;3. Haga clic en **Print** ',
	HowToSaveOrPrintMyVaccineDesc3: '3.2 Para  **usuarios de iPhone**:\n\n' +
		'&nbsp;&nbsp;1. Haga clic en icono en la parte inferior del navegador\n\n' +
		'&nbsp;&nbsp;2. Haga clic en **Print** enel menú emergente',
	HowToSaveOrPrintMyVaccineDesc3_1: '&nbsp;&nbsp;2. Haga clic en **Print** enel menú emergente',


	HowToActiveMyAccountToRetrieveMedicalInformation: 'Cómo activar la cuenta para recuperar más información médica?',
	HowToActiveMyAccountToRetrieveMedicalInformationSubTitle: '_Asegúrese de haber obtenido el "Código de acceso / Código de registro" de su médico antes de activar su cuenta._',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc1: '1. Ir a **Settings** tab\n\n' +
		'2. Haga clic en **Recuperar expediente médico**\n\n',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc2: '3. Ingrese el código obtenido del doctor\n\n' +
		'4. Haga clic en **Activar**',
	HowToSendMessage: 'Cómo enviar mensajes a un médico?',
	HowToSendMessageSubTitle: '_Si  ha  reservado  una  cita  con  su  médico,  puede  enviarle  mensajes  a través del portal  **Telehealth**._',
	HowToSendMessageDesc1: '1. Si se reserva una citacon el médico\n\n' +
		'&nbsp;&nbsp;a. Vaya a la pestaña  **Telesalud** \n\n' +
		'&nbsp;&nbsp;b. Haga clic en el icono  **Cámara** para ingresar a la sala de chat',
	HowToSendMessageDesc2: '2. **Si NOse reserva una cita con el médico\n\n' +
		'Para usuarios que utilizan la nueva interfaz de usuario en la pantalla principal:\n\n' +
		'&nbsp;&nbsp;a. Después de iniciar sesión correctamente en iClinicHealth\n\n' +
		'&nbsp;&nbsp;b. Vaya  a  la  pestaña  **Bandeja  de** y  haga  clic  en  **Cargar  más** en  la sección Mensaje\n\n' +
		'&nbsp;&nbsp;c. Haga clic en el icono  **Lápiz** en la esquina inferior derecha para redactar un mensaje nuevo\n\n' +
		'&nbsp;&nbsp;d. Haga  clic  en  el  icono  **Contacto** en la  esquina  superior  derecha  para agregar un contacto médico para completar el Asunto y el contenido, luego haga clic en  **Enviar** ',
	HowToSendMessageDesc3: 'Para usuarios que usan la IU antigua en la pantalla principal:\n\n' +
		'&nbsp;&nbsp;e. Después de iniciar sesión correctamente en iClinicHealth\n\n' +
		'&nbsp;&nbsp;f. Vaya a la pestaña  **Mensaje** \n\n' +
		'&nbsp;&nbsp;g. Haga clic en el icono  **Lápiz** en la esquina inferior derecha para redactar un nuevo mensaje\n\n' +
		'&nbsp;&nbsp;h. Haga clic en el icono **Contacto** en la esquina superior derecha para agregar un contacto médico para completar el Asunto y el contenido, luego haga clic en **Enviar** ',
	HowToExtraAccountsForFamily: 'Cómo agregar cuentas adicionales para miembros de la familia?',
	HowToExtraAccountsForFamilyDesc1: '1. Vaya a la pestaña  **Configuración** \n\n' +
		'2. Haga clic en  **Cambiar usuario** \n\n',
	HowToExtraAccountsForFamilyDesc2: '3. Haga clic en el icono  **+**',
	HowToExtraAccountsForFamilyDesc3: '4. Ingrese las nuevas credenciales de la cuenta para el inicio de sesión de un nuevo usuario',
	HowToLinkSomosAccount: 'Cómo  vincular  la  cuenta  de  SOMOS  para  recuperar  el  registro  de vacunación COVID-19?',
	HowToLinkSomosAccountDesc1: '1. Vaya a la pestaña  **Vacuna** \n\n2. Haga clic en  **Sincronizar ahora**',
	HowToLinkSomosAccountDesc3: '3. EIngrese la información de la cuenta SOMOS y haga clic en verificar',
	HowToLinkSomosAccountDesc4: '4. Entonces podrá ver su registro de vacunación COVID-19',
	HowToSendFeedBack:  'Cómo enviar comentarios sobre información incorrecta del proveedor?',
	HowToSendFeedBackDesc1: '1. Ir a **Settings** tab\n\n' +
		'2. Haga clic en  **Ayuda y comentarios**',
	HowToSendFeedBackDesc2: 'Haga clic en el icono junto a "Comentarios generales"',
	HowToSendFeedBackDesc3: 'Seleccione la opción  **Incorrect Provider Information** y escriba el contexto y haga clic en enviar en la esquina superior derecha',
	SendFeedBackAndAskQuestion: 'EnviarRegreso o hacer una pregunta',
	HelpAndFeedBack: 'Ayuda y comentarios',
	HowToUseAccessCode: '¿Cómo hacer una visita de telesalud inmediatamente usando el "Código de Acceso" de iClinicHealth',
	HowToSignUp: '¿Cómo inscribirse en iClinicHealth',
	HowToSearchAndBookAppointment: '¿Cómo buscar y reservar una cita con iClinicHealth',
	HowToUseTeleMedicine: '¿Cómo utilizar la telemedicina',
	HowToBookTeleHealth: '¿Cómo reservar una cita de telesalud a través de iClinicHealth?',
	HowToAccessTeleHealthWithCode: 'Cómo acceder a Telesalud a través de un código de acceso?',
	HowToShareFiles: 'Cómo compartir archivos a través de Telesalud?',
	FindADoctor: 'Prueba el nombre del médico, la especialidad',
	DoctorList: 'Lista de médicos',
	PopSearch: 'Búsquedas populares',
	Specialty: 'Especialidad',
	SelectASpecialty: 'Seleccione una especialidad',
	LanguagePreference: 'Preferencia de idioma',
	DoctorGender: 'Género del médico',
	Female: 'Mujer',
	Male: 'Hombre',
	DoesnotMatter: 'No importa',
	AppointmentType: 'Tipo de cita',
	AnyType: 'Cualquier tipo',
	AvailableTime: 'Tiempo disponible',
	Today: 'Hoy',
	InAWeek: 'En una semana',
	InAMonth: 'En un mes',
	AnyDays: 'Cualquier día',
	AppleFilter: 'Aplicar filtro',
	Clear: 'Limpiar',
	AnySpecialty: 'Cualquier especialidad',
	Hide:'Ocultar',
	LocationAndContact: 'Ubicación y Contacto',
	SelectATime: 'Seleccionar hora',
	NoMoreAvailableAppointmentSlots: 'No hay plazas disponibles',
	NoMoreAvailableOfficeLocation: 'No hay ubicación de oficina disponible',
	Alert: 'Alerta',
	NoSelectedAvailableTime: 'Por favor, seleccione una hora',
	NoAvailableTIme: 'No hay citas disponibles para este día - por favor, seleccione otro día :)',
	NoAvailableLocations: 'Actualmente no hay citas disponibles',
	YourAppointmentIsConformed: 'Su cita está confirmada.',
	MyAppointment: 'Mi cita',
	MemoPlaceHolder: '¿Hay algo que quiera comunicar al médico antes de la cita',
	DoctorProfile: 'Perfil del Doctor',
	Scan: 'Scan',
	InvalidQRCode: 'Código QR inválido',
	ScanCorrectQRCodeTips: 'Por favor, escanea el código QR correcto',
	GetDoctorInfoFailed: 'Obtener información del médico fallida',
	AppointmentDetail: 'Detalles de la cita',
	NoResultFound: 'No hay resultados que coincidan.',
	SearchSuggestions: 'Sugerencias de búsqueda: ',
	CheckYourSpelling: 'Comprueba tu ortografía',
	TryMoreGeneralWords: 'Prueba más palabras generales',
	UseFilter1: 'Busque en nuestra ',
	UseFilter2: 'lista de médicos',
	UseFilter3: ' y utilice el filtro para encontrar el médico adecuado',
	UseQRCodeToBookAppointment: 'Utilice el código QR que aparece a continuación para reservar una cita con su médico desde nuestra aplicación directamente',
	QRCodeManageAppointment: 'Con nuestra app, también puedes gestionar tus citas, hacer check-ins virtuales, y acceder a tu historial médico y de visitas. Todo en un solo lugar',
	CurrentNotAvailable: 'Actualmente no disponible',
	RecentSearch: 'Búsquedas recientes',
	LoadMore: 'Cargar más',
	NoMoreRecords: 'No hay más registros',
	OfficeLocationUnspecified: 'Ubicación de la oficina no especificada',
	Call: 'Llamar a la clínica',
	Share: 'Share',
	OpenWithBrowser: 'Abrir con navegador',
	ThankYou: 'Gracias!',
	VerifyNotes1: 'Necesitamos verificar su identidad antes de vincular sus datos de salud de ',
	Healthix: 'Healthix',
	VerifyNotes2: ' a esta cuenta para mantener su registro médico seguro.',
	WhatIsIdme: '¿Qué es ID.me?',
	IDmeNote: 'Verifique una vez y desbloquee el acceso a funciones exclusivas solo disponibles para invitados verificados. ',
	LearnMore: 'Aprende más',
	VerifySuccessNote: "¡Hemos verificado tu identidad! Puede consultar su (s) informe (s) de Healthix en Informe de laboratorio una vez que esté disponible.",
	IdentityVerification: 'Verificación de identidad',
	TypeOfAppointment: 'Tipo de cita',
	OfficePhoneNumber: 'Número de teléfono de la oficina',
	Address: 'Dirección',
	AppointmentMemo: 'Nota de nombramiento',
	Nearest: 'Más cerca',
	Cancel: 'Cancelar',
	EarliestAvailability: 'Disponibilidad más temprana',
	ShareDoctorTitle: "Recomiendo un gran médico que encontré en la aplicación iClinicHealth.",
	SeeMonthlyView: 'ver vista mensual',
	SaveImageAsProfile: 'Guardar perfil como imagen',
	CopyProfileLink: 'Copiar el enlace del perfil',
	Copied: 'Enlace copiado',
	InSpecialty: 'En la especialidad',
	BookFailed: 'libro fallido',
	PrimaryCare: 'Medicina Interna, Medicina de Familia, Atención Primaria',
	PrimaryCares: 'Atención Primaria',
	Pediatrics: 'Pediatría',
	OBGYN: 'Obstetra Ginecólogo (OB-GYN)',
	PainManagement: 'Manejo del Dolor',
	InternalMedicine: 'Medicina Interna',
	FamilyMedicine: 'Medicina de familia',
	Jan: 'Jan',
	Feb: 'Feb',
	Mar: 'Mar',
	Apr: 'Apr',
	Mays: 'May',
	Jun: 'Jun',
	Jul: 'Jul',
	Aug: 'Aug',
	Sep: 'Sep',
	Oct: 'Oct',
	Nov: 'Nov',
	Dec: 'Dec',
	Sun: 'Sun',
	Mon: 'Mon',
	Tue: 'Tue',
	Wed: 'Wed',
	Thu: 'Thu',
	Fri: 'Fri',
	Sat: 'Sat',
	Feedback: 'Reacción',
	GeneralFeedback: 'Retroalimentación general',
	IncorrectProviderInformation: 'Información incorrecta del proveedor',
	ScheduleAnAppointment: 'Agendar una cita de trabajo',
	FindDoctor: 'Encontrar una doctora',
	OtherQuestions: 'Otras preguntas',
	Email: 'Correo electrónico',
	FeedbackDetails: 'Detalles de la retroalimentación',
	SendFeedback: 'Enviar comentarios',
	FeedbackContentPlaceholder: '¡Déjanos un mensaje y te responderemos!',
	PleaseEnterEmailAddress: 'Por favor, introduzca su dirección de correo electrónico.',
	PleaseEnterValidEmail: 'Por favor, introduce una dirección de correo electrónico válida.',
	PleaseEnterFeedbackDetails: 'Ingrese los detalles de los comentarios.',
	Confirmation: 'Confirmación',
	ThanksForYourFeedback: 'Gracias por tus comentarios',
	OurSupportTeamIsOnIt: 'Nuestro equipo de soporte está en eso.',
	YouWillGetEmailReplySoon: 'Pronto recibirá una respuesta por correo electrónico.',
	BackToHome: 'De vuelta a casa',
	RequestFailed: 'Solicitud fallida, inténtalo de nuevo.',
	ContactUs: 'Contacta con nosotras',
	GoBack: 'Regresa',
	Yesterday: 'El día de ayer',
	MeasureHistory: 'Historial de medidas',
	AddData: 'Agregar datos',
	ShowAllMeasureHistory: 'Mostrar todo el historial de medidas',
	AllRecordedData: 'Todos los datos registrados',
	UnitSettings: 'Configuración de la unidad',
	Save: 'Ahorrar',
	LastWeek: 'La semana pasada',
	LastMonth: 'El mes pasado',
	LastQuarter: 'Trimestre más reciente',
	LastYear: 'El año pasado',
	AllTime: 'Todo el tiempo',
	Average: 'Promedio',
	High: 'Alta',
	Low: 'Bajo',
	NoRecentData: 'Sin datos recientes',
	About: 'Sobre',
	Options: 'Opciones',
	Unit: 'Unidad',
	ShowAllData: 'Mostrar todos los datos',
	Systolic: 'Sistólica',
	Diastolic: 'Diastólica',
	Invalid: 'Inválida',
	SubmitSuccess: 'Enviado satisfactoriamente',
	Date: 'Fecha',
	Time: 'Tiempo',
	BloodPressure: 'Presión arterial',
	BloodOxygen: 'Oxígeno en sangre',
	BloodGlucose: 'Glucosa en sangre',
	HeartRate: 'Ritmo cardiaco',
	Temperature: 'La temperatura',
	Height: 'Altura',
	Weight: 'Peso',
	NoData: 'Sin datos',
	Source: 'Fuente',
	BodyTemperature: 'Temperatura corporal',
	ManualInput: 'Entrada manual',
	YourBMI: 'Tu BMI',
	CalculateBaseOnLatestValue: 'calculado en base a su última altura y peso',
	Add: 'agregar',
	GetYourBMICalculated: 'para calcular su IMC',
	WeAreUpdatingMyMonitorView: 'Estamos actualizando la vista myMonitor.',
	GoTo: 'Ir',
	ToSeeTheOldView: 'para ver la vista anterior',
	MyAccount: 'Mi Cuenta',
	AddNewRecordTips: '¿No hay datos recientes? Haga clic para agregar un nuevo registro.',
	InMaintenance: 'En mantenimiento',
	AppointmentCalendarTips: (doctorName, appointmentTime, officeLocation, officePhone) => {
		let tips = 'Su cita con el Dr.' + doctorName;

		if (officeLocation) {
			tips += (' (' + officeLocation)
		}
		if (officePhone) {
			tips += (', ' + officePhone)
		}

		if (officeLocation || officePhone) {
			tips += ')'
		}

		if (appointmentTime) {
			tips += (' a las ' + appointmentTime)
		}

		tips += ' es casi la hora.';
		return tips //Su cita con el Dr. Smith (32nd Street, 123-456-9999) a las 10:00 es casi la hora.
	},
}

const Chinese = {
	Schedule: '我的预约',
	Medication: '我的用药',
	Education: '健康资讯',
	LabReport: '体检报告',
	VisitHistory: '我的病历',
	Vaccination: '疫苗记录',
	MyMonitor: '健康监测',
	InviteFriend: '邀请好友',
	NearByPharmacy: '附近药房',
	Telehealth: '远程医疗',
	Vaccine: '疫苗',
	MedicalFiles: '医疗档案',
	Message: '我的信箱',
	Insurance: '我的保险',
	New: '新',
	BookAppointmentForCovid19Vaccination: '预约COVID-19疫苗接种',
	BookFromSomos: '从 SOMOS Community Care 预约',
	ApologizeForNoTimeSlots: '对于给您带来的不便，我们深表歉意,目前没有可用的时间段,请稍后再检查,',
	VaccineQualification: '疫苗资格',
	UpcomingAppointments: '预约日程',
	AppointmentShowUp: '如果您已经接种了COVID-19疫苗，您的疫苗接种记录将显示在这里,',
	FirstName: '名字',
	LastName: '姓氏',
	MidName: '中间名',
	dob: '出生日期',
	VaccinationRecord: '疫苗记录',
	Coivd19AndYou: 'COVID-19与你',
	January: '一月',
	February: '二月',
	March: '三月',
	April: '四月',
	May: '五月',
	June: '六月',
	July: '七月',
	August: '八月',
	September: '九月',
	October: '十月',
	November: '十一月',
	December: '十二月',
	Sunday: '星期日',
	Monday: '星期一',
	Tuesday: '星期二',
	Wednesday: '星期三',
	Thursday: '星期四',
	Friday: '星期五',
	Saturday: '星期六',
	GetDirection: '导航',
	AppointmentInfo: '预约详情',
	CancelAppointment: '取消预约',
	GetVaccinatedTIps1:'1.携带带照片的身份证件和您的医疗保险卡(如果您有的话. 赴约)',
	GetVaccinatedTIps2:'2.带着有资格接种疫苗的证明去就诊,这可以包括员工身份证、您的员工或附属机构的信件或工资单,',
	ArriveEarly:'提前15分钟到达！',
	NoUpComingAppointment: '您没有即将到来的预约,',
	PageNotFound: '我们似乎找不到你要找的东西,',
	OOPS: '噢!',
	NotSomosData: '没有看到您的SOMOS疫苗接种预约或记录详情?',
	SyncNow: '马上同步',
	ReadMore: '更多',
	InPerson: '线下门诊',
	Virtual: '线上问诊',
	ViewAll: '浏览全部',
	BookAppointment: '预约',
	NoAvailableDays: '今日无可预约时间，请选择其他时间。',
	pleaseSelectLocation:'请挑选诊所地址以查询可预约时间,',
	HowToActiveMyAccount: '怎样修改我的基本信息?',
	HowToActiveMyAccountDesc1: '1. 打开iClinicHealth点击 **设置** 页面，点击顶部头像区域打开个人信息详情页',
	HowToActiveMyAccountDesc2: '2. 点击编辑按钮进入全部信息编辑界面，或者点击对应信息进入编辑界面',
	HowToSaveOrPrintMyVaccine: '怎样保存或者打印我的医疗信息?',
	HowToSaveOrPrintMyVaccineDesc1: '1. 打开指定医疗信息界面，点击右上角 **…** 按钮 \n\n',
	HowToSaveOrPrintMyVaccineDesc1_1: '2. 点击 **浏览器打开**  ',
	HowToSaveOrPrintMyVaccineDesc2: '3.1 对于安卓系统用户:\n\n' +
		'&nbsp;&nbsp;1. 点击浏览器右上角的图标',
	HowToSaveOrPrintMyVaccineDesc2_1:
		'&nbsp;&nbsp;2. 点击菜单上的 **分享...**',
	HowToSaveOrPrintMyVaccineDesc2_2: '&nbsp;&nbsp;3. 点击 **打印** ',
	HowToSaveOrPrintMyVaccineDesc3: '3.2 对于苹果用户:\n\n' +
		'&nbsp;&nbsp;1. 点击浏览器右上角的图标',
	HowToSaveOrPrintMyVaccineDesc3_1:
		'&nbsp;&nbsp;2. 点击弹出菜单上的 **打印** ',
	HowToActiveMyAccountToRetrieveMedicalInformation: '怎样激活账号以获取更多医疗信息? ',
	HowToActiveMyAccountToRetrieveMedicalInformationSubTitle: '_在开始激活流程前，请确保您已经从医生那获取到激活码(事实上，激活码就是注册码)._',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc1: '1. 打开iClinicHealth点击 **设置** 页面，点击 **获取病历**',
	HowToActiveMyAccountToRetrieveMedicalInformationDesc2: '2. 入从医生那获取的激活码，点击 **激活**',
	HowToSendMessage: '怎样发信息给我的医生? ',
	HowToSendMessageSubTitle: '_如果您有预约远程问诊，那么您可以直接在远程问诊中给医生发信息,如果没有预约远程问诊，您还可以通过如下方式给医生发信息,_',
	HowToSendMessageDesc1: '1. **如果与医生预约了时间** \n\n\n\n' +
		'&nbsp;&nbsp;a. 切换到 **远程医疗** 标签\n\n\n\n' +
		'&nbsp;&nbsp;b. 点击 **视频** 按钮并进入聊天界面',
	HowToSendMessageDesc2: '2. **如果还没有与医生预约了时间** \n\n' +
		'对于使用 **新界面** 的用户:\n\n' +
		'&nbsp;&nbsp;a. 成功登陆iClinicHealth以后\n\n' +
		'&nbsp;&nbsp;b. 进入 **信箱** 标签，在信息部分下点击 **加载更多** \n\n' +
		'&nbsp;&nbsp;c. 点击右下角的[新信息]图标，起草新的信息\n\n' +
		'&nbsp;&nbsp;d. 点击右上角的 **联系人** 图标，添加医生联系人，填写主题和内容, 最后点击发送,',
	HowToSendMessageDesc3: '对于使用旧界面的用户:\n\n' +
		'&nbsp;&nbsp;e. 成功登陆iClinicHealth以后\n\n' +
		'&nbsp;&nbsp;f. 切换到 **信箱** 标签\n\n' +
		'&nbsp;&nbsp;c. 点击右下角的[新信息]图标，起草新的信息\n\n' +
		'&nbsp;&nbsp;d. 点击右上角的 **联系人** 图标，添加医生联系人，填写主题和内容, 最后点击发送,',
	HowToExtraAccountsForFamily: '如何为家庭成员添加额外的账户?',
	HowToExtraAccountsForFamilyDesc1: '1. 切换到 **设置** 标签\n\n2. 点击 **切换账号** \n\n',
	HowToExtraAccountsForFamilyDesc2:
		'3. 点击 **+** 按钮',
	HowToExtraAccountsForFamilyDesc3: '4. 输入新的Health ID进行新用户登录',
	HowToLinkSomosAccount: '如何连接SOMOS账户以检索COVID-19疫苗接种记录?',
	HowToLinkSomosAccountDesc1: '1. 切换到 **疫苗** 标签\n\n2. 点击 **立即同步**',
	HowToLinkSomosAccountDesc3: '3. 输入SOMOS账户信息并点击验证',
	HowToLinkSomosAccountDesc4: '4. 然后你将能够查看你的COVID-19疫苗接种记录',
	HowToSendFeedBack:  '如何对不正确的医疗机构信息进行反馈?',
	HowToSendFeedBackDesc1: '1. 进入 **设置** 标签\n\n' +
		'2. 点击 **帮助与反馈**',
	HowToSendFeedBackDesc2: '3. 点击 "一般反馈 "旁边的图标',
	HowToSendFeedBackDesc3: '4. 选择选项 **不正确的医疗信息** 并输入反馈信息，点击右上角的发送,',
	SendFeedBackAndAskQuestion: '反馈或提问',
	HelpAndFeedBack: '帮助与反馈',
	HowToUseAccessCode: 'How to do a telehealth visit immediately using iClinicHealth “Access Code”?',
	HowToSignUp: 'How to sign up to iClinicHealth?',
	HowToSearchAndBookAppointment: 'How to search and book an appointment with iClinicHealth?',
	HowToUseTeleMedicine: 'How to use telemedicine?',
	HowToBookTeleHealth: '如何通过iClinicHealth预约远程医疗?',
	HowToAccessTeleHealthWithCode: '如何通过访问码访问Telehealth?',
	HowToShareFiles: '如何通过Telehealth分享文件?',
	FindADoctor: '试试医生的名字、专科',
	DoctorList: '医生列表',
	PopSearch: '热门搜索',
	Specialty: '专科',
	SelectASpecialty: '选择一个专科',
	LanguagePreference: '语言首选项',
	DoctorGender: '医生的性别',
	Female:'女',
	Male:'男',
	DoesnotMatter: '任意',
	AppointmentType: '预约类型',
	AnyType:'任何类型',
	AvailableTime: '可用时间',
	Today: '今天',
	InAWeek: '一周内',
	InAMonth: '一个月内',
	AnyDays: '任意时间',
	AppleFilter: '点击查找',
	Clear: '清除',
	AnySpecialty: '任意专科',
	Hide:'隐藏',
	LocationAndContact: '位置和联系方式',
	SelectATime:'选择时间',
	NoMoreAvailableAppointmentSlots: '没有可用的预约时段',
	NoMoreAvailableOfficeLocation: '没有可用的办公地点',
	Alert: '警报',
	NoSelectedAvailableTime: '请选择一个时间',
	NoAvailableTIme: '这一天没有可用的预约 - 请选择一个不同的日子 :) ',
	NoAvailableLocations: '目前没有任何预约',
	YourAppointmentIsConformed: '您的预约已被确认',
	MyAppointment: '查看我的预约',
	MemoPlaceHolder: '在预约之前，你有什么想让医生知道的吗？',
	DoctorProfile: '医生信息',
	Scan: '扫码',
	InvalidQRCode: '无效二维码',
	ScanCorrectQRCodeTips: '请扫描正确二维码',
	GetDoctorInfoFailed: '获取医生信息失败',
	AppointmentDetail: '预约详情',
	NoResultFound: '没有找到匹配的结果',
	SearchSuggestions: '搜索建议: ',
	CheckYourSpelling: '检查你的拼写',
	TryMoreGeneralWords: '尝试更多的一般词汇',
	UseFilter1: '浏览我们的',
	UseFilter2: ' 医生列表 ',
	UseFilter3: '，并通过筛选来查找合适的医生',
	UseQRCodeToBookAppointment: '使用下面的二维码，直接从我们的应用程序中预约你的医生',
	QRCodeManageAppointment: '通过我们的应用程序，你也可以管理你的预约，做线上签到，并访问你的医疗记录和访问历史。一切都在一个地方！',
	CurrentNotAvailable: '暂无可选日期',
	RecentSearch: '最近搜索',
	LoadMore: '加载更多',
	NoMoreRecords: '没有更多的记录了',
	OfficeLocationUnspecified: '暂无诊所地点',
	Call: '联系诊所',
	Share: '分享',
	OpenWithBrowser: '浏览器打开',
	ThankYou: '谢谢!',
	VerifyNotes1: '在将您的',
	Healthix: 'Healthix',
	VerifyNotes2: '健康数据关联到此账户前, 我们需要进行身份验证, 以保证您医疗记录的安全。',
	WhatIsIdme: '什么是ID.me?',
	IDmeNote: '您只需验证一次就可获得仅对已验证用户开放的功能的访问权限。 ',
	LearnMore: '了解更多',
	VerifySuccessNote: "我们已经验证了您的身份！当其可浏览时, 您可以在体检报告栏内查看您来自Healthix的报告。",
	IdentityVerification: '身份验证',
	TypeOfAppointment: '预约类型',
	OfficePhoneNumber: '诊所电话',
	Address: '地址',
	AppointmentMemo: '预约备忘录',
	Nearest: '距离最近',
	Cancel: '取消',
	EarliestAvailability: '最近可预约',
	ShareDoctorTitle: "我在iClinicHealth应用程序发现了一位很棒的医生。",
	SeeMonthlyView: '查看月度视图',
	SaveImageAsProfile: '保存医生名片',
	CopyProfileLink: '复制医生名片链接',
	Copied: '链接已复制到张贴板',
	InSpecialty: '专科',
	BookFailed: '预约失败',
	PrimaryCare: '内科、家庭医生、家庭医生(PCP)',
	InternalMedicine: '内科',
	FamilyMedicine: '家庭医生',
	PrimaryCares: '家庭医生(PCP)',
	Pediatrics: '儿科医生',
	OBGYN: '妇产科医生',
	PainManagement: '痛症专科医生',
	Jan: '1月',
	Feb: '2月',
	Mar: '3月',
	Apr: '4月',
	Mays: '5月',
	Jun: '6月',
	Jul: '7月',
	Aug: '8月',
	Sep: '9月',
	Oct: '10月',
	Nov: '11月',
	Dec: '12月',
	Sun: '星期日',
	Mon: '星期一',
	Tue: '星期二',
	Wed: '星期三',
	Thu: '星期四',
	Fri: '星期五',
	Sat: '星期六',
	Feedback: '反馈',
	GeneralFeedback: '意见反馈',
	IncorrectProviderInformation: '医生信息错误',
	ScheduleAnAppointment: '预约',
	FindDoctor: '找医生',
	OtherQuestions: '其他问题',
	Email: '邮箱',
	FeedbackDetails: '反馈详情',
	SendFeedback: '发送反馈',
	FeedbackContentPlaceholder: '给我们留言，我们会尽快回复您！',
	PleaseEnterEmailAddress: '请输入您的电子邮件地址。',
	PleaseEnterValidEmail: '请输入有效的电子邮件地址。',
	PleaseEnterFeedbackDetails: '请输入反馈详情。',
	Confirmation: '确认',
	ThanksForYourFeedback: '感谢您的反馈意见',
	OurSupportTeamIsOnIt: '我们的支持团队正在努力。',
	YouWillGetEmailReplySoon: '您将很快收到一封电子邮件回复。',
	BackToHome: '返回首页',
	RequestFailed: '请求失败，请重试',
	ContactUs: '联系我们',
	GoBack: '返回',
	Yesterday: '昨天',
	MeasureHistory: '测量历史',
	AddData: '添加数据',
	ShowAllMeasureHistory: '显示所有历史记录',
	AllRecordedData: '所有历史数据',
	UnitSettings: '单位设置',
	Save: '保存',
	LastWeek: '最近一周',
	LastMonth: '最近一月',
	LastQuarter: '最近一季',
	LastYear: '最近一年',
	AllTime: '所有时间',
	Average: '平均',
	High: '最高',
	Low: '最低',
	NoRecentData: '没有最近的数据',
	About: '关于',
	Options: '选项',
	Unit: '单位',
	ShowAllData: '显示所有数据',
	Systolic: '高压',
	Diastolic: '低压',
	Invalid: '无效的',
	SubmitSuccess: '提交成功',
	Date: '日期',
	Time: '时间',
	BloodPressure: '血压',
	BloodOxygen: '血氧',
	BloodGlucose: '血糖',
	HeartRate: '心率',
	Temperature: '体温',
	Height: '身高',
	Weight: '体重',
	NoData: '没有数据',
	Source: '来源',
	BodyTemperature: '体温',
	ManualInput: '手动输入',
	YourBMI: '您的 BMI',
	CalculateBaseOnLatestValue: '根据您的最新身高和体重计算',
	Add: '添加',
	GetYourBMICalculated: '以计算您的 BMI',
	WeAreUpdatingMyMonitorView: '我们正在更新 myMonitor 视图。',
	GoTo: '去',
	ToSeeTheOldView: '切换旧视图',
	MyAccount: '我的',
	AddNewRecordTips: '没有最新数据？单击以添加新记录。',
	InMaintenance: '维护中',
	AppointmentCalendarTips: (doctorName, appointmentTime, officeLocation, officePhone) => {
		let tips = '您与' + doctorName + '医生';

		if (officeLocation) {
			tips += ('(' + officeLocation)
		}
		if (officePhone) {
			tips += ('，' + officePhone)
		}

		if (officeLocation || officePhone) {
			tips += ')'
		}

		if (appointmentTime) {
			tips += ' ' + appointmentTime +'的预约快到时间了。'
		}
		return tips //您与史密斯医生(32街，123-456-9999)10:00的预约快到时间了。
	},
}

export {
	English, Spanish, Chinese
}

